<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="loadLicense" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onCarparkFilterDataChange" />

      <AppFilter 
        ref="typeFilter" 
        v-on:filter-data-change="onTypeFilterDataChange" />

      <AppFilter 
        ref="customerFilter" 
        filterKey="customerID"
        v-on:filter-data-change="onCustomerFilterDataChange" />

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import AppFilter from "@/components/App/AppFilter";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_customerType',
    text: 'Type',
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: 'id',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['status'] === 'Pending' || dataItem['status'] === 'Pending Initial Payment' || dataItem['status'] === 'Terminated') {
        return helper.plFormPLNum(dataItem.licenseOperatorNum, dataItem.carparkID);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.id}">${helper.plFormPLNum(dataItem.licenseOperatorNum, dataItem.carparkID)}</a>`;
    },
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_customer'];
      if(!dataItem.id) {
        return '';
      }
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      }
    },
  },
  {
    key: 'status',
    text: 'Status',
  },
  {
    key: '_subscription',
    text: 'Subscription',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a href="${helper.WEB_URL}/plLease?carparkID=${dataItem.carparkID}&customerID=${dataItem.customerID}&licenseID=${dataItem.id}">Subscription</a>`;
    },
  },
];

export default {
  name: "PagePLCarpark",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppTable,
    AppAddButton,
    AppModalForm,
    AppFilter,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License' },
      ],

      PARAM,

      pageCarpark: null,
      pageCustomer: null,
      pageLicense: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['customerFilter'].formatFilterOptionText = (dataItem) => dataItem.nationalID ? `${dataItem.name} (${dataItem.nationalID})` : dataItem.name;
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = this.allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, this.pageCarpark), this.$route.query.carparkID);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['customerFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);

          if(helper.checkRoleIsParker()) {
            // if(helper.checkRoleIsCompany()) {
            //   this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Company', name:'Company'}]);
            // } else {
            //   this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Personal', name:'Personal'}]);
            // }
            this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Company', name:'Company'}, {id:'Personal', name:'Personal'}]);
          } else {
            this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Company', name:'Company'}, {id:'Personal', name:'Personal'}]);
          }

          this.pageCustomer = response.data;

          let setCustomerFilter = false;

          let customerID = this.$route.query.customerID;
          if(customerID) {
            let customer = this.pageCustomer.find(k => String(k.id) === String(customerID));
            if(customer) {
              this.$refs['typeFilter'].setFilterValue(customer.isCompany ? 'Company' : 'Personal');
              this.setCustomerFilter();
              setCustomerFilter = true;
            }
          }

          if(!setCustomerFilter) {
            this.setCustomerFilter();
          }

          this.loadLicense();
        })
        .catch(error => {
          this.$refs['customerFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCustomerFilter() {
      let filterData = this.pageCustomer.filter(k => this.$refs['typeFilter'].filterValue === 'Company' ? k.isCompany : !k.isCompany);

      if(this.$refs['carparkFilter'].filterValue) {
        let parkingLicenseUnderCarpark = this.allParkingLicense.filter(k => helper.compareID(k.carparkID, this.$refs['carparkFilter'].filterValue));
        filterData = filterData.filter(k => parkingLicenseUnderCarpark.some(j => j.customerID === k.id));
      }

      filterData = [{name: 'All Customer'}].concat(filterData);
      this.$refs['customerFilter'].setFilterDataWithValueIfFirstLoad(filterData, this.$route.query.customerID);
    },
    loadLicense() {
      let feedbackItem = 'parking license data';
      this.$refs['pageTable'].setTableLoading('Loading ' + feedbackItem);

      let url = this.getUrl(this.$refs['carparkFilter'].filterValue);
      let filterCustomer = this.$refs['customerFilter'].filterValue;
      if(this.$refs['typeFilter'].filterValue === 'Personal') {
        url += '?isCompany=0';
      } else {
        url += '?isCompany=1';
      }
      if(filterCustomer) {
        url += '&customerID=' + filterCustomer;
      }
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          response.data.sort((a, b) => b.createDate - a.createDate);
          this.pageLicense = response.data;
          this.setLicense();
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    setLicense() {
      let temp = this.pageLicense;
      temp.forEach(k => {
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['carparkID']);
        k['_carparkName'] = (k['_carpark'] || {}).name;
        k['_customer'] = this.pageCustomer.find(j => j.id === k['customerID']);
        if(k['_customer']) {
          k['_customerType'] = k['_customer'].isCompany ? 'Company' : 'Personal';
        }
      });

      temp = temp.filter(k => k['_customer'] && (this.$refs['typeFilter'].filterValue === 'Company' ? k['_customer'].isCompany : !k['_customer'].isCompany));
      
      let filterCustomer = this.$refs['customerFilter'].filterValue;
      if(filterCustomer) {
        temp = temp.filter(k => k['_customer'] && helper.compareID(k['_customer']['id'], filterCustomer));
      }

      this.$refs['pageTable'].setTableData(temp, this.$refs['pageTable'].getCurrentPage());
    },

    getUrl(carparkID) {
      let url = helper.SERVER_URL + '/api2';
      if(carparkID) {
        url += '/carpark/' + carparkID;
      }
      url += '/license/';
      return url;
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(true, 'Add New City');
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Edit ' + tableData[tableDataIndex]['name'], tableData[tableDataIndex]);
    },

    onTablePageChange() {
      this.loadLicense();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadLicense();
    },
    onCarparkFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadLicense();
    },
    onTypeFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      this.setCustomerFilter();
      // this.setLicense();
      this.loadLicense();
    },
    onCustomerFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      // this.setLicense();
      this.loadLicense();
    },

    onModalAddDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Adding ' + selectedData.name);

      this.$http
        .post(
          this.getUrl(),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating ' + selectedData.name);

      this.$http
        .put(
          this.getUrl(),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    onModalDeleteDataClick(selectedData) {
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadLicense();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLCarpark.vue